document.addEventListener('DOMContentLoaded', () => {
  const maxSteps = 3;
  const currentPage = {
    title: document.title.replace(/– lumixfps.com.au$/i, ''),
    url: window.location.pathname
  };

  const container = document.querySelector('.custom-breadcrumbs');
  if (currentPage.url === '/') {
    localStorage.removeItem('breadcrumbs');
    if (container) container.style.display = 'none';
    return;
  }

  let breadcrumbs = JSON.parse(localStorage.getItem('breadcrumbs')) || [];

  breadcrumbs = breadcrumbs.filter(b => b.url !== currentPage.url);
  breadcrumbs.push(currentPage);

  if (breadcrumbs.length > maxSteps) breadcrumbs.shift();

  localStorage.setItem('breadcrumbs', JSON.stringify(breadcrumbs));

  if (container) {
    container.style.display = 'block';
    let html = '<ol class="breadcrumb-list" itemscope itemtype="https://schema.org/BreadcrumbList">';

    html += `<li class="breadcrumb-item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
               <a href="/" itemprop="item"><span itemprop="name">Home</span></a>
               <meta itemprop="position" content="1" />
             </li>`;

    breadcrumbs.forEach((b, index) => {
      const isLast = index === breadcrumbs.length - 1;
      const displayName = b.title;

      html += `<li class="breadcrumb-item ${isLast ? 'current' : ''}" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                 <span class="separator">/</span>
                 ${isLast 
                   ? `<span itemprop="name">${displayName}</span>` 
                   : `<a href="${b.url}" itemprop="item"><span itemprop="name">${displayName}</span></a>`}
                 <meta itemprop="position" content="${index + 2}" />
               </li>`;
    });

    html += '</ol>';
    container.innerHTML = html;
  }
});